const golangZeroDateStr = '0001-01-01T00:00:00Z';

export function isZeroDate(date: string) {
  return date === golangZeroDateStr;
}
